<template>
  <folder-settings />
</template>

<script>
import FolderSettings from './FolderSettings.vue'

export default {
  name: 'Domain',
  components: { FolderSettings },
  data: () => ({}),
}
</script>
